import { r2PaletteColors } from '../layout/themes'

const transactionTypes = () => [
    // { id: "DEFAULT", name: "resources.collections.types.default", color: r2PaletteColors.blue },
    { id: "REGULAR", name: "resources.collections.types.regular", color: r2PaletteColors.green },
    { id: "PROCESSED", name: "resources.collections.types.processed", color: r2PaletteColors.purple },
    { id: "DIRECT", name: "resources.collections.types.direct", color: r2PaletteColors.purple },

]

export default transactionTypes